import { render, staticRenderFns } from "./ProgressBarSection.vue?vue&type=template&id=06c580af&scoped=true"
import script from "./ProgressBarSection.vue?vue&type=script&lang=js"
export * from "./ProgressBarSection.vue?vue&type=script&lang=js"
import style0 from "./ProgressBarSection.vue?vue&type=style&index=0&id=06c580af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c580af",
  null
  
)

export default component.exports